import * as React from 'react';

import { Card } from 'components/card/card';
import { Page } from 'components/page/page';
import { ActivitiesPanel } from './activities-panel';

export const MarketingActivities: React.FC = () => (
    <Page className="pmx-marketing" title="اکتیویتی‌ها">
        <Card>
            <ActivitiesPanel hint="همه‌ی تماس‌ها، پیامک‌ها و اقدامات ثبت‌شده روی کاربران. پیامک‌های گروهی و کمپین‌ها خودکار اینجا ثبت می‌شوند." />
        </Card>
    </Page>
);
